import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  onMessage,
  deleteToken,
} from "firebase/messaging";

let getTokenFunction = null;
let onMessageListenerFunction = null;
let deleteTokenFunction = null;

try {
  var firebaseConfig = {
    apiKey: "AIzaSyBHRK0npy-v9GA9m1e7PRIw9SxY9TcVZ1I",
    authDomain: "beremote-ios.firebaseapp.com",
    databaseURL: "https://beremote-ios.firebaseio.com",
    projectId: "beremote-ios",
    storageBucket: "beremote-ios.appspot.com",
    messagingSenderId: "308105042912",
    appId: "1:308105042912:web:9f3e1c287a892f7bd8a985",
    measurementId: "G-WS9VCHL6HV",
  };

  const app = initializeApp(firebaseConfig);

  const messaging = getMessaging(app);

  getTokenFunction = async () => {
    return getToken(messaging, {
      vapidKey:
        "BKSS9rrhnXi7vwZJScjW3opyYEcPmHfSfIJMpBvSupZfWfnWNqNYPZ-RTlgdekN9Wyj1f1gLTY30zleq0OYVJqE",
    })
      .then((currentToken) => {
        if (currentToken) {
          return currentToken;
        } else {
          console.log(
            "No registration token available. Request permission to generate one."
          );
        }
      })
      .catch((err) => {
        console.log("An error occurred while retrieving token. ", err);
      });
  };

  deleteTokenFunction = () => {
    return deleteToken(messaging).then((result) => {
      console.log(result);
    });
  };

  onMessageListenerFunction = () => {
    return new Promise((resolve) => {
      onMessage(messaging, (payload) => {
        let newData = JSON.parse(payload.data.data);
        resolve({
          id: payload.messageId,
          created_at: new Date().toISOString(),
          read_at: false,
          type: payload.data.type,
          team_id: newData.team_id,
          data: newData,
        });
      });
    });
  };
} catch (e) {
  getTokenFunction = () => {
    return new Promise((resolve, reject) => {
      reject("firebase not supported");
    });
  };

  onMessageListenerFunction = () => {
    return new Promise((resolve, reject) => {
      reject("firebase not supported");
    });
  };
}

export const getTokens = getTokenFunction;
export const deleteTheToken = deleteTokenFunction;
export const onMessageListener = onMessageListenerFunction;
